<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="130px"
      class="form form-large"
    >
      <el-form-item label="所属门店" prop="store_id">
        <v-select-store class="w100" v-model="post.store_id"/>
      </el-form-item>

      <el-form-item label="课程类型" prop="card_type_id">
        <v-select-card-type-id class="w100" v-model="post.card_type_id" :store-id="post.store_id"/>
      </el-form-item>

      <el-form-item label="注意事项" prop="course_tip_id">
        <v-select-course-tip class="w100" v-model="post.course_tip_id"/>
      </el-form-item>

      <el-form-item label="专栏名称" prop="course_column_name">
        <el-input v-model="post.course_column_name" maxlength="32" show-word-limit clearable/>
      </el-form-item>

      <v-image-upload
        v-model="post.cover"
        label="专栏封面"
        prefix="course-columns"
        ratio="1:1"
        prop-name="cover"
        :is-edit="true"
      />

      <el-form-item label="课卡扣次" prop="decrement_number">
        <v-input-money
          v-model="post.decrement_number"
          :is-show-suffix="true"
          suffix-name="次"
          placeholder="请输入预约专栏课程的整体课卡扣次"
        />
      </el-form-item>

      <el-form-item label="通卡扣卡天数">
        <v-input-money
          class="w100"
          :min="0"
          :max="36600"
          v-model="post.decrement_days"
          placeholder="请输入通卡预约所扣天数"
          :is-show-suffix="true"
          suffix-name="天"
        />
      </el-form-item>

      <el-form-item label="可约人数" prop="student_number">
        <v-input-number
          v-model="post.student_number"
          type="unsignedTinyInt"
          :is-show-suffix="true"
          suffix-name="人"
          placeholder="请输入专栏可预约的人数"
        />
      </el-form-item>

      <el-form-item label="预约开始时间" prop="start_time">
        <el-date-picker
          v-model="post.start_time"
          :picker-options="pickerOptionsOfAfterSystemStartDay"
          type="datetime"
          value-format="timestamp"
          placeholder="请选择预约开始时间"
        />
      </el-form-item>

      <el-form-item label="预约结束时间" prop="end_time">
        <el-date-picker
          v-model="post.end_time"
          :picker-options="pickerOptionsOfAfterSystemStartDay"
          type="datetime"
          value-format="timestamp"
          placeholder="请选择预约结束时间"
        />
      </el-form-item>

      <el-form-item label="禁止通卡预约">
        <el-switch v-model="post.is_disable_term" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后可禁止学员使用通卡预约"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="禁止次卡预约">
        <el-switch v-model="post.is_disable_number" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后可禁止学员使用次卡预约"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="禁止课次券预约">
        <el-switch v-model="post.is_disable_ticket" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后可禁止学员使用课次券预约"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="禁止取消预约">
        <el-switch v-model="post.is_disable_cancel" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，学员可在预约结束时间前取消预约"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="禁止排队">
        <el-switch v-model="post.is_disable_queue" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后可禁止学员在专栏约满后加入排队"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="可微信支付预约">
        <el-switch v-model="post.is_we_chat_pay" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后可使用微信支付预约专栏"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item v-if="post.is_we_chat_pay" label="专栏价格" prop="price">
        <v-input-money
          placeholder="请输入专栏课程的整体价格"
          v-model="post.price"
          :is-show-suffix="true"
        />
      </el-form-item>

      <el-form-item v-if="post.is_we_chat_pay && post.is_disable_term" label="通卡价格" prop="term_price">
        <v-input-money
          class="w100"
          placeholder="请选择输入通卡会员购买课程专栏的价格"
          v-model="post.term_price"
          :is-show-suffix="true"
        />
      </el-form-item>

      <el-form-item label="可单独预约">
        <el-switch v-model="post.is_reservable_solo" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，专栏课程无法单独预约，开启后专栏课程可单独进行预约设置，学员也可以单独预约专栏的所属课程"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="不在课程列表展示">
        <el-switch v-model="post.is_hide_in_list" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后，小程序的首页课表、门店课表、老师课表均不展示专栏课程"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="仅工作人员可分享">
        <el-switch v-model="post.is_staff_share_only" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后，小程序专栏课程的分享功能将仅限后台系统录入的工作人员使用"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.courseColumnList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { pickerOptionsOfAfterSystemStartDay } from '@/utils/formats';
  import { show, update } from '@/api/course-column';
  import { toCent, toSecond, toYuan } from "@/filters";
  import { toMillisecond } from "@/utils/number";
  const validatePrice = (rule, value, callback) => {
    callback(value ? undefined : new Error('请输入专栏价格'));
  };

  const validateDecrementNumber = (rule, value, callback) => {
    callback(value ? undefined : new Error('请输入专栏课卡扣次'));
  };

  export default {
    name: RouteConfig.courseColumnEdit.name,
    data() {
      return {
        RouteConfig,
        isSaving: false,
        post: {
          store_id: '',
          card_type_id: '',
          course_tip_id: '',
          update_time: 0,
          course_column_name: '',
          cover: '',
          price: 0,
          term_price: 0,
          decrement_number: 1,
          decrement_days: 0,
          student_number: 30,
          start_time: '',
          end_time: '',
          is_disable_number: 0,
          is_disable_ticket: 0,
          is_disable_term: 0,
          is_disable_queue: 0,
          is_we_chat_pay: 0,
          is_reservable_solo: 0,
          is_hide_in_list: 0,
          is_staff_share_only: 0,
        },
        rules: {
          store_id: [{ required: true, message: '请选择专栏所属门店', trigger: 'change' }],
          card_type_id: [{ required: true, message: '请选择专栏课程类型', trigger: 'change' }],
          course_tip_id: [{ required: true, message: '请选择课程注意事项', trigger: 'change' }],
          course_column_name: [{ required: true, message: '请输入专栏名称', trigger: 'change' }],
          cover: [{ required: true, message: '请上传专栏封面', trigger: 'change' }],
          decrement_number: [{ required: true, message: '请输入专栏课卡扣次', validator: validateDecrementNumber, trigger: 'change' }],
          price: [{ required: true, message: '请输入专栏价格', validator: validatePrice, trigger: 'change' }],
          term_price: [{ required: true, message: '请选择输入通卡会员购买课程专栏的价格', trigger: 'change' }],
          student_number: [{ required: true, validator: this.validateStudentNumber, trigger: 'change' }],
          start_time: [{ required: true, message: '请选择专栏预约开始时间', trigger: 'change' }],
          end_time: [{ required: true, message: '请选择专栏预约结束时间', trigger: 'change' }],
        },
        pickerOptionsOfAfterSystemStartDay,
      };
    },
    computed: {
      id() {
        return +this.$route.params.id || 0;
      },
    },
    beforeMount() {
      this.show();
    },
    methods: {
      validateStudentNumber(rule, value, callback) {
        setTimeout(() => {
          callback(this.post.student_number ? undefined : new Error('请输入可约人数'));
        }, 0);
      },
      async show() {
        const { isError, data } = await show(this.id);
        if (isError) return;

        const { post } = this;
        const newPost = {};
        Object.keys(data).forEach(key => {
          if (key in post) newPost[key] = data[key];
        });
        newPost.price = toYuan(newPost.price);
        newPost.term_price = toYuan(newPost.term_price);
        newPost.decrement_number = toYuan(newPost.decrement_number);
        newPost.decrement_days = toYuan(newPost.decrement_days);
        newPost.start_time = toMillisecond(newPost.start_time);
        newPost.end_time = toMillisecond(newPost.end_time);
        Object.assign(post, newPost);
      },
      handleSubmit() {
        if (this.isSaving) return;

        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;

          this.isSaving = true;
          const post = { ...this.post };
          post.price = toCent(post.price);
          post.term_price = toCent(post.term_price);
          post.decrement_number = toCent(post.decrement_number);
          post.decrement_days = toCent(post.decrement_days);
          post.start_time = toSecond(post.start_time);
          post.end_time = toSecond(post.end_time);

          const { isError } = await update(this.id, post);
          this.isSaving = false;
          if (!isError) RouteConfig.courseColumnList.back();
        });
      },
    },
  };
</script>
